import debounce from 'lodash/debounce';
import {RefObject, useMemo} from 'react';
import {OnlyInLoginChecker} from '../../../../../../common/checkers/OnlyInLoginChecker';
import {ScheduledLastPageFetcher} from '../../../../../../common/fetchers/ScheduledLastPageFetcher';
import {useAddWindowEventListener} from '../../../../../../common/useAddWindowEventListener.hook';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {events} from '../constant/textViewerSagaEvents';

/**
 * 스크롤 텍스트 뷰어의 진행도 저장/로드를 지원하기 위한 컨테이너입니다.
 */
export function ScrollTextViewerProgressContainer({
  seriesId,
  productId,
  isCmsPreview,
  wrapperRef,
}: {
  seriesId: number;
  productId: number;
  isCmsPreview?: boolean;
  wrapperRef?: RefObject<HTMLDivElement>;
}) {
  const {
    chapterCount,
    currentRate,
    currentChapterId,
    isContentLoaded,
    isDrawing,
    isDone,
  } = useTypedSelector(state => ({
    chapterCount: state.textViewer.viewData[productId]?.chapterCount,
    currentRate: state.textViewer.viewData[productId]?.currentRate,
    currentChapterId: state.textViewer.viewData[productId]?.currentChapterId,
    isContentLoaded: state.textViewer.viewData[productId]?.isContentLoaded,
    isDrawing: state.textViewer.viewData[productId]?.isDrawing,
    isDone: state.textViewer.viewData[productId]?.isDone,
  }));

  const dispatch = useTypedDispatch();

  // 스크롤 모드
  const onScroll = useMemo(
    () =>
      debounce(() => {
        if (!wrapperRef || !isContentLoaded || isDrawing) {
          return;
        }
        const div = wrapperRef.current;
        const wrapperStartY = div?.offsetTop || 0;
        const wrapperBottomY = (div?.offsetTop || 0) + (div?.offsetHeight || 0);
        dispatch(
          events.updateScrollViewerCurrentRateRequired({
            productId,
            wrapperStartY,
            wrapperBottomY,
          })
        );
      }, 100),
    [dispatch, isContentLoaded, isDrawing, productId, wrapperRef]
  );

  useAddWindowEventListener({type: 'scroll', listener: onScroll});

  if (isCmsPreview) {
    return null;
  }

  return (
    <OnlyInLoginChecker>
      {currentRate !== undefined &&
        currentChapterId !== undefined &&
        chapterCount !== undefined && (
          <ScheduledLastPageFetcher
            seriesId={seriesId}
            productId={productId}
            rate={currentRate}
            spineIndex={currentChapterId}
            isDone={!!isDone}
          />
        )}
    </OnlyInLoginChecker>
  );
}
